export const createCursor = () => {
    const cursor = document.createElement("a-entity");
    cursor.innerHTML = `
        <a-entity
            id="cursor-controller"
            cursor 
            raycaster="objects: .collidable, .interactable, .intersectable, .ui; far: 20;interval:10;showLine:true;autoRefresh:true;"
        >
        </a-entity>
    `;

    // cursor.innerHTML = `
    //     <a-entity
    //         id="cursor-controller"
    //         raycastervr="objects: .collidable, .interactable, .intersectable, .ui; far: 20;interval:10;showLine:false;autoRefresh:true;"
    //         cursor-controller="cursor: #cursor; camera: #player-camera;maxDistance:4;"
    //     >
    //     </a-entity>
    //     <a-entity
    //         geometry="primitive: sphere; radius: 0.0075: segments-height:9;segments-width:9"
    //         collision-filter="collisionForces: false"
    //         event-repeater="events:raycaster-intersection, raycaster-intersection-cleared; eventSource: #cursor-controller"
    //         id="cursor"
    //         material="depthTest: false; opacity:0.9;color: #ffffff"
    //         velocity=""
    //         static-body="shape: sphere;"
    //         super-hands="\n colliderEvent: raycaster-intersection; colliderEventProperty: els;\n colliderEndEvent: raycaster-intersection-cleared; colliderEndEventProperty: clearedEls;\n grabStartButtons: cursor-grab; grabEndButtons: cursor-release;\n stretchStartButtons: cursor-grab; stretchEndButtons: cursor-release;\n\t\t\t\tdragDropStartButtons: cursor-grab; dragDropEndButtons: cursor-release;"
    //         visible="">
    //     </a-entity>
    // `;

    return cursor;
};
